import React from 'react';
import {Route, Switch} from 'react-router';
import Login from '@/pages/Login';
import Menu from "@/pages/Menu";
import Apply from "@/pages/register/Apply";
import Propose from "@/pages/register/Propose";
import Register from "@/pages/register/Register";
import RegisterConfirm from "@/pages/register/RegisterConfirm";
import WatashiCard from "@/pages/watashi/WatashiCard";
import WatashiCardEdit from "@/pages/watashi/WatashiCardEdit";
import Schedule from "@/pages/schedule/Schedule";
import UketoriList from "@/pages/uke/UketoriList";
import UketoriCard from "@/pages/uke/UketoriCard";
import UketoriCardMemo from "@/pages/uke/UketoriCardMemo";
import Upload from "@/pages/card/Upload";
import Cards from "@/pages/card/Cards";
import Uketori from "@/pages/uke/Uketori";
import WatashiQR from "@/pages/watashi/WatashiQR";
import AddSchedule from "@/pages/schedule/AddSchedule";
import HomePage from "@/pages/homePage/HomePage";
import Profile from "@/pages/profile/Profile";
import EditProfile from "@/pages/profile/EditProfile";
import EditHomePage from "@/pages/homePage/EditHomePage";
import Setting from "@/pages/Setting";
import ChangePassword from "@/pages/password/ChangePassword";
import {Subscription} from "@/pages/subscription/Subscription";
import {Purchase} from "@/pages/subscription/Purchase";
import {Trade} from "@/pages/subscription/Trade";
import {Top} from "@/pages/Top";
import ForgotPassword from "@/pages/password/ForgotPassword";
import ResetPassword from "@/pages/password/ResetPassword";
import EditHomeComponentPage from "@/pages/homePage/EditHomeComponentPage";
import AddHomeComponentPage from "@/pages/homePage/AddHomeComponentPage";
import WatashiSchedule from "@/pages/schedule/WatashiSchedule";
import EditSchedule from "@/pages/schedule/EditSchedule";
import RegisterDone from "@/pages/register/RegisterDone";
import CodeConfirm from "@/pages/register/CodeConfirm";
import UketoriCardHomePage from "@/pages/uke/UketoriCardHomePage";
import Term from "@/pages/term/Term";
import TermInfo from "@/pages/term/TermInfo";
import Commercial from "@/pages/term/Commercial";
import UketoriQRPage from "@/pages/uke/UketoriQRPage";
import UketoriCardSchedulePage from "@/pages/uke/UketoriCardSchedule";
import ScheduleEdit from "@/pages/schedule/ScheduleEdit";
import About from "@/pages/About";
import Uses from "@/pages/Uses";
import Restriction from "@/pages/Restriction";
import Showcase from "@/pages/showcase/Showcase";

export const isNoNeedLogins = (location) => {
  const openPrefixes = ['/login', '/showcase']
  return openPrefixes.some((l) => location.startsWith(l))
}

const routes = (
  <div>
    <Switch>
      <Route exact path="/" component={Top}/>
      <Route exact path="/login" component={Login}/>
      <Route exact path="/about" component={About}/>
      <Route exact path="/uses" component={Uses}/>
      <Route exact path="/restriction" component={Restriction}/>

      <Route exact path="/menu" component={Menu}/>
      <Route exact path="/setting" component={Setting}/>
      <Route exact path="/changePassword" component={ChangePassword}/>
      <Route exact path="/password" component={ForgotPassword}/>
      <Route exact path="/password/reset/:code" component={ResetPassword}/>

      <Route exact path="/card" component={Cards}/>
      <Route exact path="/card/upload" component={Upload}/>

      <Route exact path="/register/propose" component={Propose}/>
      <Route exact path="/register/apply" component={Apply}/>
      <Route exact path="/register/register" component={Register}/>
      <Route exact path="/register/confirm" component={RegisterConfirm}/>
      <Route exact path="/register/done" component={RegisterDone}/>
      <Route exact path="/code/confirm/:code" component={CodeConfirm}/>

      <Route exact path="/watashi/:id(\d+)/qr" component={WatashiQR}/>
      <Route exact path="/watashi/:id(\d+)/edit" component={WatashiCardEdit}/>
      <Route exact path="/watashi/:id(\d+)" component={WatashiCard}/>

      <Route exact path="/schedule/add" component={AddSchedule}/>
      <Route exact path="/schedule/add/:date" component={AddSchedule}/>
      <Route exact path="/schedule/edit/:date" component={EditSchedule}/>
      <Route exact path="/schedule/:id(\d+)" component={WatashiSchedule}/>
      <Route exact path="/schedule" component={Schedule}/>
      <Route exact path="/schedule/edit" component={ScheduleEdit}/>

      <Route exact path="/uketori/:id(\d+)/schedule" component={UketoriCardSchedulePage}/>
      <Route exact path="/uketori/:id(\d+)/homePage" component={UketoriCardHomePage}/>
      <Route exact path="/uketori/:id(\d+)/memo" component={UketoriCardMemo}/>
      <Route exact path="/uketori/:id(\d+)" component={UketoriCard}/>
      <Route exact path="/uketori/:cardId(\d+)/:code" component={Uketori}/>
      <Route exact path="/uketori/qr" component={UketoriQRPage}/>
      <Route exact path="/uketori" component={UketoriList}/>

      <Route exact path="/profile" component={Profile}/>
      <Route exact path="/profile/edit" component={EditProfile}/>

      <Route exact path="/homePage" component={HomePage}/>
      <Route exact path="/homePage/edit" component={EditHomePage}/>
      <Route exact path="/homePage/edit/:id(\d+)" component={EditHomeComponentPage}/>
      <Route exact path="/homePage/add" component={AddHomeComponentPage}/>
      <Route exact path="/homePage/:id(\d+)" component={HomePage}/>

      <Route exact path="/subscription" component={Subscription}/>
      <Route exact path="/purchase" component={Purchase}/>
      <Route exact path="/trade/:id" component={Trade}/>

      <Route exact path="/termInfo" component={TermInfo}/>
      <Route exact path="/term" component={Term}/>
      <Route exact path="/commercial" component={Commercial}/>

      <Route exact path="/showcase/:id(\d+)" component={Showcase}/>
    </Switch>
  </div>
)

export default routes;
